/**
 * @fileoverview DELETE handler for the "/apps/:app_id/push_credential" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { appsAppIdPushCredentialCacheKeys } from "./constants";
import type { DeleteAppsAppIdPushCredentialProps } from "./types";

export const deleteAppsAppIdPushCredential = reactQueryMutationAdapter(
  appsAppIdPushCredentialCacheKeys,
  (props: DeleteAppsAppIdPushCredentialProps): Promise<void> => {
    return fetch(`/apps/${props.appId}/push_credential`, "DELETE", props);
  }
);
